import { PetBreed } from '@/types'

export const dogBreeds: PetBreed[] = [
  {
    id: 'golden-retriever',
    name: 'Golden Retriever',
    type: 'dog',
    origin: 'İskoçya',
    characteristics: ['Sevecen', 'Sosyal', 'Zeki'],
    careNotes: ['Düzenli egzersiz', 'Tüy bakımı', 'Zihinsel oyunlar'],
    image: '/golden-retriever.webp',
    description: 'Aile dostu, çocuklarla iyi anlaşan, enerjik ve eğitime açık bir ırktır.',
    weightKg: [25, 34],
    heightCm: [55, 61],
    lifeSpanYears: [10, 12],
    grooming: 'medium',
    activity: 'high',
    familyFriendly: 5
  },
  {
    id: 'german-shepherd',
    name: 'German Shepherd Dog',
    type: 'dog',
    origin: 'Almanya',
    characteristics: ['Zeki', 'Çalışkan', 'Koruyucu'],
    careNotes: ['Günlük yoğun egzersiz', 'Zihinsel uyarım', 'Düzenli tüy bakımı'],
    image: '/german-shepherd.webp',
    description: 'Görev köpeği olarak bilinen, zeki ve çok yönlü bir çalışma köpeği.',
    weightKg: [22, 40],
    heightCm: [55, 65],
    lifeSpanYears: [9, 13],
    grooming: 'medium',
    activity: 'high',
    familyFriendly: 4
  },
  {
    id: 'border-collie',
    name: 'Border Collie',
    type: 'dog',
    origin: 'Birleşik Krallık',
    characteristics: ['Aşırı zeki', 'Atletik', 'Odaklı'],
    careNotes: ['Yüksek egzersiz', 'İtaat/çeviklik sporu', 'Zeka oyunları'],
    image: '/border-collie.webp',
    description: 'Dünyanın en zeki ırklarından, yüksek enerji ve iş odaklılık ile bilinir.',
    weightKg: [14, 20],
    heightCm: [46, 56],
    lifeSpanYears: [12, 15],
    grooming: 'medium',
    activity: 'high',
    familyFriendly: 4
  },
  {
    id: 'french-bulldog',
    name: 'French Bulldog',
    type: 'dog',
    origin: 'Fransa',
    characteristics: ['Sakin', 'Sevecen', 'Apartman dostu'],
    careNotes: ['Kısa yürüyüşler', 'Sıcak-soğuğa dikkat', 'Yüz kırışıklık bakımı'],
    image: '/french-bulldog.webp',
    description: 'Kısa burunlu, sakin mizaca sahip, aile yaşamına uyumlu bir ırk.',
    weightKg: [8, 13],
    heightCm: [28, 33],
    lifeSpanYears: [10, 12],
    grooming: 'low',
    activity: 'low',
    familyFriendly: 5
  },
  {
    id: 'labrador-retriever',
    name: 'Labrador Retriever',
    type: 'dog',
    origin: 'Kanada',
    characteristics: ['Dost canlısı', 'Atletik', 'Sadık'],
    careNotes: ['Yüzme ve koşu', 'Dengeli beslenme', 'Düzenli sağlık kontrolü'],
    image: '/labrador-retriever.webp',
    description: 'Sosyal ve aktif bir ırktır, rehber ve arama-kurtarma köpeği olarak da kullanılır.',
    weightKg: [25, 36],
    heightCm: [54, 57],
    lifeSpanYears: [10, 14],
    grooming: 'medium',
    activity: 'high',
    familyFriendly: 5
  },
  {
    id: 'sivas-kangal',
    name: 'Sivas Kangal',
    type: 'dog',
    origin: 'Türkiye',
    characteristics: ['Koruyucu', 'Güçlü', 'Sadık'],
    careNotes: ['Geniş alan', 'Sosyalizasyon', 'Düzenli egzersiz'],
    image: '/sivas-kangal.webp',
    description: 'Güçlü koruma içgüdüsü olan, sakin ve sadık bir çoban köpeğidir.',
    weightKg: [40, 65],
    heightCm: [72, 78],
    lifeSpanYears: [10, 13],
    grooming: 'medium',
    activity: 'medium',
    familyFriendly: 4
  },
  {
    id: 'beagle',
    name: 'Beagle',
    type: 'dog',
    origin: 'Birleşik Krallık',
    characteristics: ['Meraklı', 'Neşeli', 'Sosyal'],
    careNotes: ['Koku oyunları', 'Düzenli yürüyüş', 'Temel itaat eğitimi'],
    image: '/beagle.webp',
    description: 'Koklayarak iz sürmeyi sever, aileler için uygun, enerjik bir ırktır.',
    weightKg: [9, 11],
    heightCm: [33, 38],
    lifeSpanYears: [12, 15],
    grooming: 'low',
    activity: 'medium',
    familyFriendly: 5
  },
  {
    id: 'poodle-cani',
    name: 'Poodle (Kaniş)',
    type: 'dog',
    origin: 'Fransa',
    characteristics: ['Alerji dostu', 'Zeki', 'Eğitime açık'],
    careNotes: ['Tüy traşı ve bakım', 'Zihin egzersizleri', 'Sosyalleşme'],
    image: '/poodle.webp',
    description: 'Hipoalerjenik tüy yapısı ve yüksek zekasıyla bilinen çok yönlü bir ırk.',
    weightKg: [20, 32],
    heightCm: [45, 60],
    lifeSpanYears: [12, 15],
    grooming: 'high',
    activity: 'high',
    familyFriendly: 5
  }
]

export const catBreeds: PetBreed[] = [
  {
    id: 'british-shorthair',
    name: 'British Shorthair',
    type: 'cat',
    origin: 'Birleşik Krallık',
    characteristics: ['Sakin', 'Uysal', 'Bağımsız'],
    careNotes: ['Tarama', 'Dengeli beslenme', 'Düzenli oyun'],
    image: '/british-shorthair.webp',
    description: 'Sakin mizacı ve sevecen yapısıyla aileler için ideal bir kedi ırkıdır.',
    weightKg: [3, 7],
    heightCm: [30, 35],
    lifeSpanYears: [15, 20],
    grooming: 'low',
    activity: 'low',
    familyFriendly: 5
  },
  {
    id: 'persian',
    name: 'Persian',
    type: 'cat',
    origin: 'İran',
    characteristics: ['Sakin', 'Uysal', 'Sevecen'],
    careNotes: ['Günlük tarama', 'Göz bakımı', 'Düzenli veteriner kontrolü'],
    image: '/persian.webp',
    description: 'Uzun tüylü, sakin mizaca sahip, düzenli tüy bakımı gerektiren klasik bir ırk.',
    weightKg: [3, 6],
    heightCm: [25, 30],
    lifeSpanYears: [12, 16],
    grooming: 'high',
    activity: 'low',
    familyFriendly: 5
  },
  {
    id: 'ragdoll',
    name: 'Ragdoll',
    type: 'cat',
    origin: 'ABD',
    characteristics: ['Nazik', 'Kucak sever', 'Sakin'],
    careNotes: ['Haftalık tarama', 'Tırnak bakımı', 'Oyunla sosyalleşme'],
    image: '/ragdoll.webp',
    description: 'Kucakta sakinleşmesiyle bilinen, nazik ve aile dostu bir kedi ırkı.',
    weightKg: [4, 9],
    heightCm: [23, 28],
    lifeSpanYears: [12, 17],
    grooming: 'medium',
    activity: 'low',
    familyFriendly: 5
  },
  {
    id: 'bengal',
    name: 'Bengal',
    type: 'cat',
    origin: 'ABD',
    characteristics: ['Atletik', 'Meraklı', 'Etkileşimli'],
    careNotes: ['Aktif oyunlar', 'Zihin uyarımı', 'Geniş tırmalama alanı'],
    image: '/bengal.webp',
    description: 'Leopar benzeri deseni ve yüksek enerjisiyle öne çıkan modern bir ırk.',
    weightKg: [3, 7],
    heightCm: [20, 25],
    lifeSpanYears: [12, 16],
    grooming: 'low',
    activity: 'high',
    familyFriendly: 4
  },
  {
    id: 'van-cat',
    name: 'Van Kedisi',
    type: 'cat',
    origin: 'Türkiye',
    characteristics: ['Oyuncu', 'Zeki', 'Sosyal'],
    careNotes: ['Su oyunları', 'Zenginleştirme', 'Düzenli sağlık kontrolü'],
    image: '/van-kedisi.webp',
    description: 'Su sevgisiyle bilinen, enerjik ve sosyal bir yerli kedi ırkıdır.',
    weightKg: [3, 7],
    heightCm: [30, 36],
    lifeSpanYears: [12, 17],
    grooming: 'medium',
    activity: 'medium',
    familyFriendly: 4
  },
  {
    id: 'ankara-cat',
    name: 'Ankara Kedisi',
    type: 'cat',
    origin: 'Türkiye',
    characteristics: ['Zarif', 'Zeki', 'Sosyal'],
    careNotes: ['Tüy bakımı', 'Tırnak bakımı', 'İlgi ve oyun'],
    image: '/ankara-kedisi.webp',
    description: 'Uzun tüylü, zarif ve insan odaklı bir kedi ırkıdır.',
    weightKg: [3, 5],
    heightCm: [25, 30],
    lifeSpanYears: [12, 18],
    grooming: 'high',
    activity: 'medium',
    familyFriendly: 5
  },
  {
    id: 'siamese',
    name: 'Siyam Kedisi',
    type: 'cat',
    origin: 'Tayland',
    characteristics: ['Konuşkan', 'Sosyal', 'Zeki'],
    careNotes: ['Etkileşimli oyun', 'Zihin egzersizleri', 'İlgi'],
    image: '/siyam-kedisi.webp',
    description: 'Sosyal ve konuşkan yapısıyla bilinen, insanıyla güçlü bağ kuran bir ırktır.',
    weightKg: [3, 6],
    heightCm: [27, 32],
    lifeSpanYears: [12, 15],
    grooming: 'low',
    activity: 'medium',
    familyFriendly: 4
  },
  {
    id: 'maine-coon',
    name: 'Maine Coon',
    type: 'cat',
    origin: 'ABD',
    characteristics: ['Nazik dev', 'Sevecen', 'Oyuncu'],
    careNotes: ['Tarama', 'Büyük kum kabı', 'Kaliteli beslenme'],
    image: '/maine-coon.webp',
    description: 'Büyük cüssesine rağmen nazik ve sosyal bir kedi ırkıdır.',
    weightKg: [4, 8],
    heightCm: [25, 40],
    lifeSpanYears: [12, 15],
    grooming: 'medium',
    activity: 'medium',
    familyFriendly: 5
  }
]

export const allBreeds: PetBreed[] = [...dogBreeds, ...catBreeds]


